import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../src/environments/environment';
import { ReactiveService } from '../reactive-service.abstract';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { extractDomain } from '../../../../src/app/shared/helpers/domain.helper';
import {Observable} from "rxjs";

@Injectable()
export class BrandingApiService extends ReactiveService  {

  private baseUrl = environment.backEndUrlPrefix + '/' + 'db/branding';

  constructor(private http: HttpClient) {
    super();
  }

  extractUrl(): string {
    this.baseUrl = this.baseUrl.replace(
      extractDomain(this.baseUrl),
      extractDomain(document.location.href + '')
    );
    return this.baseUrl;
  }

  download(imageType: string): Observable<Object> {
    return this.http.get(`${this.baseUrl}/${imageType}`,
    { params: { domain: extractDomain(document.location.href + '') } }
    );
  }

  makeImageUrl(imageType: string): string {
    return `${environment.backEndUrlPrefix }/db/branding/${imageType}?domain=${extractDomain(document.location.href)}`
  }
  isExist(imageType: string): Observable<Object> {
    return this.http.get(`${this.baseUrl}/${imageType}/exists`,
      { params: { domain: extractDomain(document.location.href + '') } }
    );
  }

  upload(data, imageType) {
    return this.http.post(`${this.baseUrl}/${imageType}`, data,
          { params: { domain: extractDomain(document.location.href + '') } }
    );
  }

  delete(imageType) {
    return this.http.delete(`${this.baseUrl}/${imageType}`);
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Object> | Promise<Object> | Object {
    return this.download('backgroundImage');
  }

}
